import cn from 'classnames'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import { routes } from 'core/routes/paths'
import { useAuthContext } from '../../core/providers/AuthProvider'

import c from './assets/sass/tabs.module.scss'

export const Tabs = () => {
    const { t } = useTranslation()
    const location = useLocation()
    const { isAuthenticated } = useAuthContext()

    const isOnMainPage = location.pathname === routes.main
    const isAdditionalShown = isAuthenticated && isOnMainPage

    return (
        <div className={c.component}>
            {isAdditionalShown && (
                <div className={c.additional}>
                    <Link
                        className={cn(c.additionalLink, c.earnings)}
                        to={routes.earnings}
                    >
                        <span>{t('tabs.earnings')}</span>
                    </Link>
                    <Link
                        className={cn(c.additionalLink, c.leaderboard)}
                        to={routes.leaderboard}
                    >
                        <span>{t('tabs.leaderboard')}</span>
                    </Link>
                </div>
            )}
            <div className={c.wrapper}>
                <ul className={c.list}>
                    <li className={c.item}>
                        <Link
                            to={routes.profile}
                            className={cn(c.link, c.profile, {
                                [c.active]:
                                    location.pathname === routes.profile,
                            })}
                        >
                            <span>{t('tabs.profile')}</span>
                        </Link>
                    </li>
                    <li className={c.item}>
                        <Link
                            to={routes.main}
                            className={cn(c.link, c.main, {
                                [c.active]: location.pathname === routes.main,
                            })}
                        >
                            <span>{t('tabs.main')}</span>
                        </Link>
                    </li>
                    <li className={c.item}>
                        <Link
                            to={routes.games}
                            className={cn(c.link, c.games, {
                                [c.active]:
                                    location.pathname === routes.games ||
                                    location.pathname === routes.advent ||
                                    location.pathname === routes.battle ||
                                    location.pathname === routes.mines,
                            })}
                        >
                            <span>{t('tabs.modes')}</span>
                        </Link>
                    </li>
                </ul>
            </div>
            <div className={c.bg} />
        </div>
    )
}
